import { Div, Flex, Icon, P, Span } from '@dnb/eufemia';
import { chevron_down } from '@dnb/eufemia/icons';
import { ComponentPropsWithoutRef } from 'react';
import { Link } from 'react-router-dom';

import useEnterPress from '@/hooks/useEnterPress';

import style from './index.module.css'; // Adjust path if needed

interface MenuLink {
  title: string;
  to: string;
  underline?: boolean;
  subTitle?: string;
  isVisible?: boolean;
  isProfileMenu?: boolean;
  onEnterPress?: (e: KeyboardEvent) => void;
}

interface NavigationButtonElementProps {
  props: ComponentPropsWithoutRef<'a'>;
  linkTo: string;
  key?: string;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: (props: any) => any;
  onEnterPress?: (e: KeyboardEvent) => void;
}

interface MobileAccordionButtonProps {
  props: ComponentPropsWithoutRef<'button'>;
  key?: string;
  showChevron?: boolean;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: (props: any) => any;
  onEnterPress?: (e: KeyboardEvent) => void;
}

export const NavigationButtonElement = ({
  props,
  linkTo,
  key,
  title,
  icon,
  onEnterPress,
}: NavigationButtonElementProps) => {
  const linkRef = useEnterPress(onEnterPress ?? (() => {}));

  return (
    <Div className={style['buttonContainer']} key={title} ref={linkRef}>
      <Link {...props} className={style['navigationButton']} key={key} to={linkTo} type="button">
        <Flex.Horizontal align="center" justify="center">
          <Div className={style['navigationIcon']}>{icon && <Icon icon={icon} size={24} />}</Div>
          <Span className={style['navigationButtonText']}>{title}</Span>
        </Flex.Horizontal>
      </Link>
    </Div>
  );
};

export const MobileAccordionButton = ({
  props,
  showChevron,
  key,
  title,
  icon,
  onEnterPress,
}: MobileAccordionButtonProps) => {
  const linkRef = useEnterPress(onEnterPress ?? (() => {}));

  return (
    <Div className={style['buttonContainer']} key={title} ref={linkRef}>
      <button {...props} className={style['navigationButton']} key={key} type="button">
        <Flex.Horizontal align="center" justify="center">
          <Div className={style['navigationIcon']}>{icon && <Icon icon={icon} size={24} />}</Div>
          <Span className={style['navigationButtonText']}>{title}</Span>
        </Flex.Horizontal>
        {showChevron && <Icon icon={chevron_down} size={24} />}
      </button>
    </Div>
  );
};

export const LinkItem = (link: MenuLink) => {
  const linkRef = useEnterPress(link.onEnterPress ?? (() => {}));

  return (
    <Link
      className={link.isProfileMenu ? style['dropdownLinkProfile'] : style['dropdownLink']}
      id="linkItem"
      key={link.to}
      ref={linkRef}
      tabIndex={0}
      to={link.to}
    >
      <Div className={style['dropdownTextWrapper']}>
        <P className={style['dropdownTitle']}>{link.title}</P>
        {link.subTitle && (
          <P className={style['dropdownSubtitle']} size="x-small">
            {link.subTitle}
          </P>
        )}
      </Div>
    </Link>
  );
};
